import {
  getAddonsByGroup,
  getParkingByGroup,
  getProfile,
  getUpgradePackagesList,
  upgradePackage,
} from "../../../Redux/Profile/ProfileActions";
import UpgradeCardSelector from "../../../Components/User/Upgrade/UpgradeCardSelector/UpgradeCardSelector";
import FamilyMemberModal from "../../../Components/User/FamilyMemberModal/FamilyMemberModal";
import Agreement from "../../../Components/User/Bookings/Agreement/Agreement";
import Packages from "../../../Components/User/Upgrade/Packages/Packages";
import Parking from "../../../Components/User/Upgrade/Parking/Parking";
import Addons from "../../../Components/User/Upgrade/Addons/Addons";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import Modal from "../../../Components/Common/Modal/Modal";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import { LiaParkingSolid } from "react-icons/lia";
import { Link, useNavigate } from "react-router";
import { FaRegTrashAlt } from "react-icons/fa";
import { PiCarDuotone } from "react-icons/pi";
import styles from "./Upgrade.module.scss";
import { LuPackage } from "react-icons/lu";

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  bookingAllowed: boolean;
}

interface PackageItem {
  discountRate: number;
  isFamily: boolean;
  isFreeMonth: boolean;
  isMember: boolean;
  isNonMember: boolean;
  noofMember: number;
  packageAmenities: string[];
  packageDescription: string;
  packageId: number;
  packageName: string;
  totalRates: number;
}

function Upgrade() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const {
    getUpgradePackagesListData,
    getParkingByGroupData,
    getAddonsByGroupData,
    getUpgradePackagesListLoading,
    getParkingByGroupLoading,
    getAddonsByGroupLoading,
  } = useSelector((state: RootState) => state.profile);
  const { upgradePackageLoading } = useSelector(
    (state: RootState) => state.profile,
  );
  const [activeTab, setActiveTab] = useState("packages");
  const [familyMemberModalOpen, setFamilyMemberModalOpen] = useState(false);
  const [familyMembers, setFamilyMembers] = useState<FamilyMember[]>([]);
  const [selectedPackageId, setSelectedPackageId] = useState<number>(-1);
  const [parkingIds, setParkingIds] = useState<number[]>([]);
  const [notifyParkingIds, setNotifyParkingIds] = useState<number[]>([]);
  const [cardModalOpen, setCardModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState<string>("");
  const [agreementModalOpen, setAgreementModalOpen] = useState(false);
  const [signature, setSignature] = useState<string>("");
  const signRef = useRef<SignatureCanvas | null>(null);
  const [voucherCode, setVoucherCode] = useState<string>("");
  const [voucherSuccess, setVoucherSuccess] = useState<any>(null);
  const [addonSelections, setAddonSelections] = useState<
    Array<{
      addonId: number;
      noofAddonUnits: number;
      notifyAddon: boolean;
    }>
  >([]);

  const tabs = [
    {
      label: "Packages",
      value: "packages",
      icon: <LuPackage className={styles.icon} />,
    },
    {
      label: "Parking",
      value: "parking",
      icon: <LiaParkingSolid className={styles.icon} />,
    },
    {
      label: "Addons",
      value: "addons",
      icon: <IoIosAddCircleOutline className={styles.icon} />,
    },
  ];

  const selectedPackage: PackageItem | undefined =
    getUpgradePackagesListData?.packages?.find(
      (pack: PackageItem) => pack.packageId === selectedPackageId,
    );

  const handleNextTab = () => {
    switch (activeTab) {
      case "packages":
        if (selectedPackageId !== -1) {
          if (selectedPackage?.isFamily && !familyMemberModalOpen) {
            setFamilyMemberModalOpen(true);
          } else {
            setActiveTab("parking");
          }
        } else {
          setActiveTab("parking");
        }
        break;
      case "parking":
        setActiveTab("addons");
        break;
      case "addons":
        setAgreementModalOpen(true);
        break;
      default:
        break;
    }
  };

  const handleBackwardTab = () => {
    switch (activeTab) {
      case "addons":
        setActiveTab("parking");
        break;
      case "parking":
        setActiveTab("packages");
        break;
      default:
        break;
    }
  };

  const agreementHandler = () => {
    if (signRef?.current) {
      if (signRef.current.isEmpty()) {
        toastHelper.error("Please sign the agreement");
      } else {
        setSignature(signRef.current.toDataURL());
        setAgreementModalOpen(false);
        setCardModalOpen(true);
      }
    }
  };

  const familyMemberModalHandler = () => {
    if (familyMembers.length === 0) {
      toastHelper.error("Please add at least one member");
      return;
    }
    setFamilyMemberModalOpen(false);
    handleNextTab();
  };

  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
            >
              <React.Fragment>{tab.icon}</React.Fragment>
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContentContainer}>
          <div className={styles.tabContent}>
            {activeTab === "packages" && (
              <Packages
                packages={getUpgradePackagesListData?.packages ?? []}
                selectedPackageId={selectedPackageId}
                setSelectedPackageId={setSelectedPackageId}
              />
            )}

            {activeTab === "parking" && (
              <Parking
                parkings={getParkingByGroupData || []}
                parkingIds={parkingIds}
                setParkingIds={setParkingIds}
                notifyParkingIds={notifyParkingIds}
                setNotifyParkingIds={setNotifyParkingIds}
              />
            )}

            {activeTab === "addons" && (
              <Addons
                addons={getAddonsByGroupData || []}
                addonSelections={addonSelections}
                setAddonSelections={setAddonSelections}
              />
            )}
          </div>
          <Summary />
        </div>
      </React.Fragment>
    );
  };

  const upgradeHandler = () => {
    if (!upgradePackageLoading) {
      const successHandler = () => {
        setCardModalOpen(false);
        navigate("/", { replace: true });
      };

      const params: any = {};
      if (selectedPackageId !== -1) {
        params.packageSubscription = {
          newPackageId: selectedPackageId,
          signature,
          memberCCInfoId: selectedCard,
          voucherCode: voucherCode,
          familyMembers: familyMembers.length > 0 ? familyMembers : [],
        };
      }
      if (parkingIds.length > 0 || notifyParkingIds.length > 0) {
        params.parking = {
          memberCCInfoId: selectedCard,
          parkingIds,
          notifyParkingIds,
        };
      }
      if (addonSelections.length > 0) {
        params.addons = {
          memberCCInfoId: selectedCard,
          slots: addonSelections.filter((s) => s.noofAddonUnits > 0),
        };
      }

      if (!selectedCard) {
        toastHelper.error("Please select a card");
        return;
      }

      dispatch(upgradePackage({ ...params, successHandler }));
    }
  };

  useEffect(() => {
    dispatch(getProfile({ navigate: navigate }));
    dispatch(getUpgradePackagesList());
    dispatch(getParkingByGroup());
    dispatch(getAddonsByGroup());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (
    getUpgradePackagesListLoading ||
    getParkingByGroupLoading ||
    getAddonsByGroupLoading
  ) {
    return <Loading />;
  }

  const Summary = () => {
    const subTotal = useMemo(() => {
      let total = 0;
      if (selectedPackage) {
        total += selectedPackage?.totalRates - selectedPackage?.discountRate;
      }
      if (parkingIds.length > 0) {
        let totalParkingRate = 0;
        (getParkingByGroupData || []).forEach((parking: any) => {
          const slotIds = (parking?.parkingdata ?? []).map(
            (slot: { ParkingId: number }) => slot.ParkingId,
          );
          const selectedCount = parkingIds.filter((id) =>
            slotIds.includes(id),
          ).length;
          totalParkingRate +=
            (parking?.rates ?? parking?.cost ?? 0) * selectedCount;
        });
        total += totalParkingRate;
      }
      if (addonSelections.some((s) => s.noofAddonUnits > 0)) {
        let totalAddonRate = 0;
        addonSelections.forEach((s) => {
          const addon = getAddonsByGroupData?.find(
            (a: any) => a.addonId === s.addonId,
          );
          totalAddonRate += (addon?.cost ?? 0) * s.noofAddonUnits;
        });
        total += totalAddonRate;
      }

      return Number(total.toFixed(2));
    }, [selectedPackage, parkingIds, addonSelections]);

    return (
      <div className={styles.summaryContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.heading}>Summary</p>
        </div>
        <div className={styles.summaryBodyContainer}>
          {selectedPackage && (
            <div className={styles.summaryItem}>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Package</p>
              </div>
              <div className={styles.itemContent}>
                <div className={styles.itemContainer}>
                  <div className={styles.iconContainer}>
                    <LuPackage className={styles.icon} />
                  </div>
                  <div className={styles.itemName}>
                    <p className={styles.itemNameText}>
                      {selectedPackage?.packageName}
                    </p>
                  </div>
                </div>
                <div className={styles.priceContainer}>
                  <p className={styles.price}>
                    $
                    {selectedPackage?.totalRates -
                      selectedPackage?.discountRate}
                  </p>
                </div>
              </div>
            </div>
          )}
          {parkingIds.length > 0 && (
            <div className={styles.summaryItem}>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Parking</p>
                <p className={styles.count}>{parkingIds.length} Slot(s)</p>
              </div>
              {(getParkingByGroupData || []).map((parking: any) => {
                const slotIds = (parking?.parkingdata ?? []).map(
                  (slot: { ParkingId: number }) => slot.ParkingId,
                );
                const selectedCount = parkingIds.filter((id) =>
                  slotIds.includes(id),
                ).length;
                if (selectedCount === 0) return null;
                return (
                  <div className={styles.itemContent} key={parking?.amenityId}>
                    <div className={styles.itemContainer}>
                      <div className={styles.iconContainer}>
                        <PiCarDuotone className={styles.icon} />
                      </div>
                      <div className={styles.itemName}>
                        <p className={styles.itemNameText}>
                          {parking?.name ?? parking?.amenityName}
                        </p>
                        <p className={styles.itemCount}>
                          {selectedCount} Space(s)
                        </p>
                      </div>
                    </div>
                    <div className={styles.priceContainer}>
                      <p className={styles.price}>
                        $
                        {(parking?.rates ?? parking?.cost ?? 0) * selectedCount}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {addonSelections.some((s) => s.noofAddonUnits > 0) && (
            <div className={styles.summaryItem}>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Addons</p>
                <p className={styles.count}>
                  {addonSelections.filter((s) => s.noofAddonUnits > 0).length}{" "}
                  Item(s)
                </p>
              </div>
              {addonSelections
                .filter((s) => s.noofAddonUnits > 0)
                .map((s, i) => {
                  const addon = getAddonsByGroupData?.find(
                    (p: any) => p.addonId === s.addonId,
                  );
                  return (
                    <div className={styles.itemContent} key={i}>
                      <div className={styles.itemContainer}>
                        <div className={styles.iconContainer}>
                          <IoIosAddCircleOutline className={styles.icon} />
                        </div>
                        <div className={styles.itemName}>
                          <p className={styles.itemNameText}>
                            {addon?.amenityName}
                          </p>
                          <p className={styles.itemCount}>
                            {s.noofAddonUnits} Unit(s)
                          </p>
                        </div>
                      </div>
                      <div className={styles.priceContainer}>
                        <p className={styles.price}>
                          ${(addon?.cost ?? 0) * s.noofAddonUnits}
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
          <div className={styles.totalContainer}>
            <div className={styles.itemContainer}>
              <p className={styles.label}>Subtotal</p>
              <p className={styles.value}>$ {subTotal}</p>
            </div>
            <div className={styles.itemContainer}>
              <p className={styles.label}>Taxes and Fees</p>
              <p className={styles.value}>$0.00</p>
            </div>
            <div className={styles.totalItemContainer}>
              <p className={styles.label}>Total</p>
              <p className={styles.value}>$ {subTotal}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {upgradePackageLoading && <Loading />}
      <div className={styles.mainContainer}>
        <Link to="/" replace className={styles.backButtonContainer}>
          <button className={styles.button}>
            <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
            Back to Home
          </button>
        </Link>
        <div className={styles.headingContainer}>
          <p className={styles.heading}>Upgrade</p>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.tabsContainer}>{tabsRenderer()}</div>
          <div className={styles.buttonsContainer}>
            {activeTab !== "packages" && (
              <button className={styles.backButton} onClick={handleBackwardTab}>
                Back
              </button>
            )}

            {activeTab === "packages" && selectedPackageId !== -1 && (
              <button
                className={styles.clearButton}
                onClick={() => setSelectedPackageId(-1)}
              >
                <div className={styles.iconContainer}>
                  <FaRegTrashAlt className={styles.icon} />
                </div>
                <p className={styles.buttonText}>Reset Selections</p>
              </button>
            )}

            {activeTab === "parking" && parkingIds.length > 0 && (
              <button
                className={styles.clearButton}
                onClick={() => {
                  setParkingIds([]);
                  setNotifyParkingIds([]);
                }}
              >
                <div className={styles.iconContainer}>
                  <FaRegTrashAlt className={styles.icon} />
                </div>
                <p className={styles.buttonText}>Reset Selections</p>
              </button>
            )}

            {activeTab === "addons" &&
              addonSelections.some((s) => s.noofAddonUnits > 0) && (
                <button
                  className={styles.clearButton}
                  onClick={() => setAddonSelections([])}
                >
                  <div className={styles.iconContainer}>
                    <FaRegTrashAlt className={styles.icon} />
                  </div>
                  <p className={styles.buttonText}>Reset Selections</p>
                </button>
              )}

            <button
              className={styles.nextButton}
              disabled={
                activeTab === "addons" &&
                selectedPackageId === -1 &&
                !parkingIds.length &&
                !addonSelections.some((s) => s.noofAddonUnits > 0)
              }
              onClick={handleNextTab}
            >
              {activeTab === "addons" ? "Upgrade" : "Next"}
            </button>
          </div>
        </div>
      </div>
      <Modal
        isOpen={familyMemberModalOpen}
        setIsOpen={setFamilyMemberModalOpen}
      >
        <FamilyMemberModal
          familyMembers={familyMembers}
          setFamilyMembers={setFamilyMembers}
          packageData={selectedPackageId}
        />
        <div className={styles.proceedButtonContainer}>
          <button onClick={familyMemberModalHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setFamilyMemberModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={agreementModalOpen}
        setIsOpen={setAgreementModalOpen}
        showCloseIcon={false}
      >
        <Agreement
          signRef={signRef}
          termsAndConditions={getUpgradePackagesListData?.terms}
        />

        <div className={styles.proceedButtonContainer}>
          <button
            onClick={() => setAgreementModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
          <button onClick={agreementHandler} className={styles.button}>
            Proceed
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={cardModalOpen}
        setIsOpen={setCardModalOpen}
        showCloseIcon={false}
      >
        <UpgradeCardSelector
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
          label="Upgrade"
          voucher={voucherCode}
          setVoucher={setVoucherCode}
          voucherSuccess={voucherSuccess}
          setVoucherSuccess={setVoucherSuccess}
          selectedPackage={selectedPackage}
          selectedParkingIds={parkingIds}
          selectedAddons={addonSelections}
          parkingList={getParkingByGroupData || []}
          addonsList={getAddonsByGroupData || []}
        />
        <div className={styles.buttonsContainer}>
          <button
            className={styles.cancelButton}
            onClick={() => setCardModalOpen(false)}
          >
            Cancel
          </button>
          <button className={styles.button} onClick={upgradeHandler}>
            Proceed
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default Upgrade;
